import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './TenantManagement.scss';
import { fetchGetTenant } from '../../actions/Membership';

import { Button, Input } from 'reactstrap';
import { Loading } from '../../components';
import { 
  HeaderSection, 
  Modal,
  Dropdown,
  validateNumber,
  history,
  passParamsToPath,
} from '../../helpers';
import { fetchCreateTenant, fetchUpdateTenant } from '../../actions/'; 
import commonConstant from '../../common/_commonConstant';
import { createRef } from 'react/cjs/react.production.min';

class TenantManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading' : true,
      'showCreateTenantModal' : false,
      'tenantId': '',
      'tenantStatus' : '',
      'tenantCategory' : null,
      'tenantRefNo' : '',
      'tenantName' : '',
      'tenantAddress' : '',
      'carParkingPackageOne' : '',
      'carParkingPackageTwo' : '',
      'carParkingPackageThree' : '',
      'motorcycleParkingPackageSeven' : '',
      'motorcycleParkingPackageEight' : '',
      'motorcycleParkingPackageNine' : '',
      'modalType' : '',
    };

    this.tenantCategory = createRef();
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(fetchGetTenant(this.props.match.params.buildingID));
  }

  componentDidUpdate(prevProps) {
    const { createTenant, updateTenant } = this.props;

    if (createTenant.status === 200 && createTenant.type === commonConstant.CREATE_TENANT_SUCCESS && prevProps.createTenant != createTenant) {
      this.props.dispatch(fetchGetTenant(this.props.match.params.buildingID));
      this.setState({
        'loading' : false,
        'showCreateTenantModal' : false,
      });
    } else if (updateTenant.status === 200 && updateTenant.type === commonConstant.UPDATE_TENANT_SUCCESS && prevProps.updateTenant != updateTenant) {
      this.props.dispatch(fetchGetTenant(this.props.match.params.buildingID));
      this.setState({
        'loading' : false,
        'showCreateTenantModal' : false,
      });
    }
  }

  handleDataForCreateTenant = () => {
    const {       
      tenantCategory, 
      tenantRefNo, 
      tenantName, 
      tenantAddress,
      carParkingPackageOne, 
      carParkingPackageTwo,
      carParkingPackageThree,
      motorcycleParkingPackageSeven,
      motorcycleParkingPackageEight,
      motorcycleParkingPackageNine,      
    } = this.state;
      
    return {
      'buildingID': this.props.match.params.buildingID,
      'carParkingPackageOne': carParkingPackageOne != '' ? parseInt(carParkingPackageOne) : 0,
      'carParkingPackageTwo': carParkingPackageTwo != '' ? parseInt(carParkingPackageTwo) : 0,
      'carParkingPackageThree': carParkingPackageThree != '' ? parseInt(carParkingPackageThree) : 0,
      'motorcycleParkingPackageSeven': motorcycleParkingPackageSeven != '' ? parseInt(motorcycleParkingPackageSeven) : 0,
      'motorcycleParkingPackageEight': motorcycleParkingPackageEight != '' ? parseInt(motorcycleParkingPackageEight) : 0,
      'motorcycleParkingPackageNine': motorcycleParkingPackageNine != '' ? parseInt(motorcycleParkingPackageNine) : 0,
      'tenantAddress': tenantAddress,
      'tenantCategory': tenantCategory.value,
      'tenantName': tenantName,
      'tenantRefNo': tenantRefNo,
    };
  }

  handleDataForUpdateTenant = () => {
    const {       
      tenantCategory, 
      tenantId, 
      tenantName, 
      tenantAddress,
      carParkingPackageOne, 
      carParkingPackageTwo,
      carParkingPackageThree,
      motorcycleParkingPackageSeven,
      motorcycleParkingPackageEight,
      motorcycleParkingPackageNine,    
      tenantStatus,  
    } = this.state;

    return {
      'buildingID': this.props.match.params.buildingID,
      'carParkingPackageOne': carParkingPackageOne != '' ? parseInt(carParkingPackageOne) : 0,
      'carParkingPackageTwo': carParkingPackageTwo != '' ? parseInt(carParkingPackageTwo) : 0,
      'carParkingPackageThree': carParkingPackageThree != '' ? parseInt(carParkingPackageThree) : 0,
      'motorcycleParkingPackageSeven': motorcycleParkingPackageSeven != '' ? parseInt(motorcycleParkingPackageSeven) : 0,
      'motorcycleParkingPackageEight': motorcycleParkingPackageEight != '' ? parseInt(motorcycleParkingPackageEight) : 0,
      'motorcycleParkingPackageNine': motorcycleParkingPackageNine != '' ? parseInt(motorcycleParkingPackageNine) : 0,
      'tenantAddress': tenantAddress,
      'tenantCategory': tenantCategory.value,
      'tenantID': tenantId,
      'tenantName': tenantName,
      'tenantStatus': tenantStatus,
    };
  }

  handleRedirect = (tenantName) => {    
    history.push(passParamsToPath(commonConstant.pathManageTenantMembership, { 'buildingID': this.props.match.params.buildingID, 'tenantName' : tenantName, 'buildingRefNo' : this.props.match.params.buildingRefNo }));
  }

    handleTenantCard = () => {
      const { getTenants } = this.props;
      if (getTenants.length > 0) {
        return getTenants.map((ele, index) => (
          <div key={index} className="card-container">
            <div onClick={() => this.handleRedirect(ele.tenantName)} className="tenant-detail">
              <div className="tenant-detail-container">
                <div className="tenant-ref-no">{ele.tenantRefNo}</div>
                <div className="tenant-name">{ele.tenantName}</div>
              </div>
            </div>
            <div onClick={() => this.handleOpenModalType('edit', ele)} className="edit-tenant-container">
              <div className="icon icon-pencil" />
              <div>Edit</div>
            </div>
          </div>
        ));
      }
    }

    handleModalHeader = () => {
      const { modalType } = this.state;      

      switch (modalType) {
        case 'create':
          return 'สร้าง member';
        case 'edit':
          return 'แก้ไข member';        
        default:
          break;
      }
    }

    handleEvent = (key, value) => {
      this.setState({ [key] : value });

      if (key === 'tenantCategory') {
        this.tenantCategory.current.handleShowItem();
      }
    }

  handleIsCanCreate = () => {
    const {       
      tenantCategory, 
      tenantRefNo, 
      tenantName, 
      tenantAddress,
      carParkingPackageOne, 
      carParkingPackageTwo,
      carParkingPackageThree,
      motorcycleParkingPackageSeven,
      motorcycleParkingPackageEight,
      motorcycleParkingPackageNine,      
    } = this.state;
      
    const propertiesToCheck = [
      tenantCategory, 
      tenantRefNo, 
      tenantName, 
      tenantAddress,
      carParkingPackageOne, 
      carParkingPackageTwo,
      carParkingPackageThree,
      motorcycleParkingPackageSeven,
      motorcycleParkingPackageEight,
      motorcycleParkingPackageNine,       
    ];
  
    const canSave = propertiesToCheck.every(property => property !== '' && property !== null);    
    if (canSave) {
      return true;
    } else {
      return false;
    }
  }

  handleIsCanEdit = () => {
    const {       
      tenantCategory, 
      tenantStatus, 
      tenantName, 
      tenantAddress,
      carParkingPackageOne, 
      carParkingPackageTwo,
      carParkingPackageThree,
      motorcycleParkingPackageSeven,
      motorcycleParkingPackageEight,
      motorcycleParkingPackageNine,      
    } = this.state;
      
    const propertiesToCheck = [
      tenantCategory, 
      tenantStatus, 
      tenantName, 
      tenantAddress,
      carParkingPackageOne, 
      carParkingPackageTwo,
      carParkingPackageThree,
      motorcycleParkingPackageSeven,
      motorcycleParkingPackageEight,
      motorcycleParkingPackageNine,       
    ];
  
    const canSave = propertiesToCheck.every(property => property !== '' && property !== null);    
    if (canSave) {
      return true;
    } else {
      return false;
    }
  }

    handleCreateTenantModal = () => {
      const { 
        showCreateTenantModal, 
        tenantCategory, 
        tenantRefNo, 
        tenantName, 
        tenantAddress,
        carParkingPackageOne, 
        carParkingPackageTwo,
        carParkingPackageThree,
        motorcycleParkingPackageSeven,
        motorcycleParkingPackageEight,
        motorcycleParkingPackageNine,
        modalType,
        tenantStatus,
      } = this.state;
      return <Modal
        show={showCreateTenantModal ? true : false}          
        header={this.handleModalHeader()}  
        headerTemplate="a"
        handleToggle={() => this.setState({ 'showCreateTenantModal': false })}            
      >
        <div className="create-tenant-modal">
          <HeaderSection title="Tenant"/>
          <div className="create-tenant-container">
            {
              modalType === 'edit' ? 
                <div className="tenant-status-container">
                  <div className="tenant-status-label">Status</div>
                  <div className="status-button-container">
                    <div className={`status-button ${tenantStatus === 'ENABLE' ? 'active' : ''}`} onClick={() => this.handleEvent('tenantStatus', 'ENABLE')}>Enable</div>
                    <div className={`status-button ${tenantStatus === 'DISABLE' ? 'active' : ''}`} onClick={() => this.handleEvent('tenantStatus', 'DISABLE')}>Disable</div>
                  </div>
                </div>
                : null
            }
            <div className="row-1">
              <div className="tenant-category-container">
                <div className="tenant-category-label">Tenant category</div>
                <div className="tenant-category-dropdown">
                  <Dropdown
                    template="b" 
                    placeholder="Choose tenant category"
                    value={tenantCategory ? tenantCategory.value : null} 
                    ref={this.tenantCategory } 
                  >
                    {
                      commonConstant.tenantCategory.map((ele, tenantCategoryIndex) => (
                        <div
                          key={tenantCategoryIndex}
                          className={`item${tenantCategory && tenantCategory.value === ele.value ? ' active' : ''}`}
                          onClick={() => this.handleEvent('tenantCategory', ele)}
                        >{ele.label}</div>
                      ))
                    }
                  </Dropdown>
                </div>
              </div>
              <div className="tenant-ref-no-container">
                <div className="tenant-ref-no-label">Tenant ref no</div>
                <div className="tenant-ref-no-input">
                  <Input
                    disabled={modalType === 'edit'}
                    id={'tenant-ref-no-input'}
                    className={'template-d'}
                    placeholder="Input tenant ref no"
                    value={tenantRefNo}
                    maxLength={4}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (validateNumber(value)) {
                        this.handleEvent('tenantRefNo', value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row-2">
              <div className="tenant-name-container">
                <div className="tenant-name-label">Tenant name</div>
                <div className="tenant-name-input">
                  <Input
                    id={'tenant-name-input'}
                    className={'template-d'}
                    placeholder="Input tenant name"
                    value={tenantName}                    
                    onChange={(event) => {
                      const value = event.target.value;                      
                      this.handleEvent('tenantName', value);
                    }}
                  />
                </div>
              </div>
              <div className="tenant-address-container">
                <div className="tenant-address-label">Tenant address</div>
                <div className="tenant-address-input">
                  <Input
                    id={'tenant-address-input'}
                    className={'template-d'}
                    placeholder="Input tenant address"
                    value={tenantAddress}                    
                    onChange={(event) => {
                      const value = event.target.value;                      
                      this.handleEvent('tenantAddress', value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row-3">
              <div className="tenant-car-package-container">
                <div className="tenant-car-package-label">Car parking package 1</div>
                <div className="tenant-car-package-input">
                  <Input
                    id={'tenant-car-package-one-input'}
                    className={'template-d'}
                    placeholder="Input number of package"
                    value={carParkingPackageOne}                    
                    onChange={(event) => {
                      const value = event.target.value;   
                      if (validateNumber(value)) {                   
                        this.handleEvent('carParkingPackageOne', value);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="tenant-car-package-container">
                <div className="tenant-car-package-label">Car parking package 2</div>
                <div className="tenant-car-package-input">
                  <Input
                    id={'tenant-car-package-two-input'}
                    className={'template-d'}
                    placeholder="Input number of package"
                    value={carParkingPackageTwo}                    
                    onChange={(event) => {
                      const value = event.target.value;  
                      if (validateNumber(value)) {                    
                        this.handleEvent('carParkingPackageTwo', value);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="tenant-car-package-container">
                <div className="tenant-car-package-label">Car parking package 3</div>
                <div className="tenant-car-package-input">
                  <Input
                    id={'tenant-car-package-three-input'}
                    className={'template-d'}
                    placeholder="Input number of package"
                    value={carParkingPackageThree}                    
                    onChange={(event) => {
                      const value = event.target.value; 
                      if (validateNumber(value)) {                     
                        this.handleEvent('carParkingPackageThree', value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row-4">
              <div className="tenant-motorcycle-package-container">
                <div className="tenant-motorcycle-package-label">Motorcycle parking package 7</div>
                <div className="tenant-motorcycle-package-input">
                  <Input
                    id={'tenant-motorcycle-package-one-input'}
                    className={'template-d'}
                    placeholder="Input number of package"
                    value={motorcycleParkingPackageSeven}                    
                    onChange={(event) => {
                      const value = event.target.value;  
                      if (validateNumber(value)) {                    
                        this.handleEvent('motorcycleParkingPackageSeven', value);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="tenant-motorcycle-package-container">
                <div className="tenant-motorcycle-package-label">Motorcycle parking package 8</div>
                <div className="tenant-motorcycle-package-input">
                  <Input
                    id={'tenant-motorcycle-package-two-input'}
                    className={'template-d'}
                    placeholder="Input number of package"
                    value={motorcycleParkingPackageEight}                    
                    onChange={(event) => {
                      const value = event.target.value;  
                      if (validateNumber(value)) {                    
                        this.handleEvent('motorcycleParkingPackageEight', value);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="tenant-motorcycle-package-container">
                <div className="tenant-motorcycle-package-label">Motorcycle parking package 9</div>
                <div className="tenant-motorcycle-package-input">
                  <Input
                    id={'tenant-motorcycle-package-three-input'}
                    className={'template-d'}
                    placeholder="Input number of package"
                    value={motorcycleParkingPackageNine}                    
                    onChange={(event) => {
                      const value = event.target.value;                      
                      if (validateNumber(value)) {
                        this.handleEvent('motorcycleParkingPackageNine', value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

          </div>
          <div className="button-container">
            <Button disabled={modalType === 'create' ? !this.handleIsCanCreate() : !this.handleIsCanEdit() } onClick={() => this.handleCreateOrUpdateTenant()} className="btn-primary send-data-button">ส่งข้อมูล</Button>
          </div>
        </div>
      </Modal>;
    }

    handleOpenModalType = (modalType, tenantData) => {
      if (modalType === 'create') {
        this.setState({
          'tenantCategory' : null,
          'tenantRefNo' : '',
          'tenantName' : '',
          'tenantAddress' : '',
          'carParkingPackageOne' : '',
          'carParkingPackageTwo' : '',
          'carParkingPackageThree' : '',
          'motorcycleParkingPackageSeven' : '',
          'motorcycleParkingPackageEight' : '',
          'motorcycleParkingPackageNine' : '',
        });
      } else if (modalType === 'edit' && tenantData) {
        this.setState({
          'tenantCategory' : commonConstant.tenantCategory.filter((item) => item.value === tenantData.tenantCategory)[0],
          'tenantId': tenantData.tenantID,
          'tenantRefNo' : tenantData.tenantRefNo,
          'tenantName' : tenantData.tenantName,
          'tenantAddress' : tenantData.tenantAddress,
          'carParkingPackageOne' : tenantData.carParkingPackageOne.toString(),
          'carParkingPackageTwo' : tenantData.carParkingPackageTwo.toString(),
          'carParkingPackageThree' : tenantData.carParkingPackageThree.toString(),
          'motorcycleParkingPackageSeven' : tenantData.motorcycleParkingPackageSeven.toString(),
          'motorcycleParkingPackageEight' : tenantData.motorcycleParkingPackageEight.toString(),
          'motorcycleParkingPackageNine' : tenantData.motorcycleParkingPackageNine.toString(),
          'tenantStatus' : tenantData.deletedAt ? 'DISABLE' : 'ENABLE',
        });
      }
      this.setState({
        'modalType': modalType,
        'showCreateTenantModal' : true,
      });
    }

    handleCreateOrUpdateTenant = () => {
      const { modalType } = this.state;

      this.setState({
        'loading' : true,   
      });

      if (modalType === 'create') {
        this.props.dispatch(fetchCreateTenant(
          this.handleDataForCreateTenant(),
        ));
      } else if (modalType === 'edit') {
        this.props.dispatch(fetchUpdateTenant(
          this.handleDataForUpdateTenant(),
        ));
      }
    }

    render() {
      const { getTenants } = this.props;
      

      if (!getTenants) {
        return <Loading />;
      }

      return (
        <div className="TenantManagement layout-box-page">
          {this.handleCreateTenantModal()}
          <HeaderSection title={'Tenant'} />
          <div className="button-container">            
            <Button onClick={() => this.handleOpenModalType('create')} className="btn-primary create-tenant-button">              
              <span className="icon icon-add"/>
              <span>สร้างผู้เช่าใหม่</span>              
            </Button>
          </div>
          <div className="tenant-card-container">
            {
              this.handleTenantCard()
            }
          </div>
        </div>
      );
    }
}

const mapStateToProps = ({ getTenants, createTenant, updateTenant }) => ({
  'getTenants': getTenants.data,
  createTenant,
  updateTenant,
});


export default connect(mapStateToProps)(TenantManagement);

TenantManagement.propTypes = {
  'dispatch' : PropTypes.func,
  'match' : PropTypes.shape({
    'path' : PropTypes.string,
    'params' : PropTypes.shape({  
      'buildingID' : PropTypes.string,
    }),
  }),
  'getTenants' : PropTypes.array,
  'createTenant' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
  }),    
  'updateTenant' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
  }),   
};
